<template>
  <div class="exam">
    <div class="main">
      <!-- banner -->
      <div class="m">
        <div class="banner"></div>
        <div class="exam_box">
          <div class="exam_box_tit" v-if="detail">"{{detail.name}}"小测</div>
          <el-form
            ref="ruleForm"
            :model="form"
            label-width="80px"
            class="exam_list"
            label-position="top"
          >
            <el-form-item
              label="姓名："
              prop="co_user_name"
              :rules="[{required: true, message: '请填写姓名', trigger: 'blur,change'}]"
            >
              <el-input class="input689" v-model="form.co_user_name" placeholder="请输入您的真实姓名，以便生成证书" style="width:300px;"></el-input>
            </el-form-item>
            <div class="exam_list_tit">判断题</div>
            <el-form-item
              :label="item.name"
              v-for="item in pd"
              :prop="item.id"
              :rules="[{required: true, message: '请选择', trigger: 'blur,change'}]"
            >
              <el-radio-group v-model="item.user_answer" @change="test(item)">
                <el-radio label="A" v-if="item.answer1">A、{{item.answer1}}</el-radio>
                <br />
                <el-radio label="B" v-if="item.answer2">B、{{item.answer2}}</el-radio>
                <br />
                <el-radio label="C" v-if="item.answer3">C、{{item.answer3}}</el-radio>
                <br />
                <el-radio label="D" v-if="item.answer4">D、{{item.answer4}}</el-radio>
                <br />
                <el-radio label="E" v-if="item.answer5">E、{{item.answer5}}</el-radio>
                <br />
              </el-radio-group>
            </el-form-item>
            <div class="exam_list_tit">单选题</div>
            <el-form-item
              :label="item.name"
              v-for="item in dx"
              :prop="item.id"
              :rules="[{required: true, message: '请选择', trigger: 'blur,change'}]"
            >
              <el-radio-group v-model="item.user_answer" @change="test(item)">
                <el-radio label="A" v-if="item.answer1">A、{{item.answer1}}</el-radio>
                <br />
                <el-radio label="B" v-if="item.answer2">B、{{item.answer2}}</el-radio>
                <br />
                <el-radio label="C" v-if="item.answer3">C、{{item.answer3}}</el-radio>
                <br />
                <el-radio label="D" v-if="item.answer4">D、{{item.answer4}}</el-radio>
                <br />
                <el-radio label="E" v-if="item.answer5">E、{{item.answer5}}</el-radio>
                <br />
              </el-radio-group>
            </el-form-item>
            <div class="exam_list_tit">多选题</div>
            <el-form-item
              :label="item.name"
              v-for="item in duox"
              :prop="item.id"
              :rules="[{required: true, message: '请选择', trigger: 'blur,change'}]"
            >
              <el-checkbox-group v-model="item.user_answer" @change="test(item)">
                <el-checkbox label="A" v-if="item.answer1">A、{{item.answer1}}</el-checkbox>
                <br />
                <el-checkbox label="B" v-if="item.answer2">B、{{item.answer2}}</el-checkbox>
                <br />
                <el-checkbox label="C" v-if="item.answer3">C、{{item.answer3}}</el-checkbox>
                <br />
                <el-checkbox label="D" v-if="item.answer4">D、{{item.answer4}}</el-checkbox>
                <br />
                <el-checkbox label="E" v-if="item.answer5">E、{{item.answer5}}</el-checkbox>
                <br />
              </el-checkbox-group>
            </el-form-item>
            <el-button type="primary" @click="submitForm('ruleForm')">提 交</el-button>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {
    myHeader,
    myFooter
  },
  data() {
    return {
      detail:null,
      form: {
        co_user_name: ""
      }, //答案
      list: [], //问卷列表
      pd: [], //判断题列表
      dx: [], //单选题列表
      duox: [] //多选题列表
    };
  },
  computed: {
    info() {
      return this.$store.state.info;
    }
  },
  created() {
    this.getFontExam();
    this.getFrontColleges();
  },

  methods: {
     // 获取课程详情
    getFrontColleges() {
      let params = {
        code: this.$route.query.code,
        loginKey: sessionStorage.getItem("loginKey")
      };
      return new Promise(resolve => {
        this.api.getFrontColleges(params).then(res => {
          this.detail = res.obj.list[0] || null;
          resolve();
        });
      });
    },
    // form生成键值对
    test(item) {
      this.form = Object.assign({}, this.form, { [item.id]: item.user_answer });
    },
    submitForm(formName, type) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.checkExam();
        } else {
          this.$message.error("您还有题目未填写，请根据提示填写后再试！");
          return false;
        }
      });
    },
    // 小测提交
    checkExam() {
      let form = this.form;
      let params = {
        entityCode: this.$route.query.code,
        ExamJson: []
      };
      for (const i in form) {
        if (i != "co_user_name") {
          params.ExamJson.push({
            id: i,
            user_answer: form[i] instanceof Array ? form[i].join(",") : form[i]
          });
        }
      }
      params.ExamJson = JSON.stringify(params.ExamJson);
      params.co_user_name = form.co_user_name;
      params.loginKey = sessionStorage.getItem("loginKey");
      this.api.checkExam(params).then(res => {
        if (res.error["err_code"] !== 0) return;
        if (res.obj.checkFlag) {
          this.$confirm("本次考试已通过?", "提示", {
            confirmButtonText: "下载学时证明",
            cancelButtonText: "返回视频首页",
            type: "success"
          })
            .then(() => {
              this.$router.push({
                name: "personal_cneter_hz_school_certificate"
              });
            })
            .catch(() => {
              this.$router.push({
                name: "school"
              });
            });
        } else {
          this.$alert("答题正确率需达到100%才能够通过小测噢~", "提示", {
            confirmButtonText: "重新测试",
            type: "warning"
          });
        }
      });
    },
    // 小测列表
    getFontExam() {
      let params = {
        code: this.$route.query.code,
        loginKey: sessionStorage.getItem("loginKey")
      };
      this.api.getFontExam(params).then(res => {
        if (res.error["err_code"] !== 0) return;
        let list = res.obj.list;
        let pd = []; //判断题
        let dx = []; //单选
        let duox = []; //多选
        // 题目类型筛选
        list.forEach(item => {
          if (item.class_one === "COExamTypeJudge") {
            pd.push(item);
          } else if (item.class_one === "COExamTypeSingle") {
            dx.push(item);
          } else if (item.class_one === "COExamTypeMultiple") {
            item.user_answer = [];
            duox.push(item);
          }
        });
        //同类题目排序
        pd.sort((a, b) => {
          return a.sequence - b.sequence;
        });
        dx.sort((a, b) => {
          return a.sequence - b.sequence;
        });
        duox.sort((a, b) => {
          return a.sequence - b.sequence;
        });
        this.pd = pd;
        this.dx = dx;
        this.duox = duox;
        // // 题目答案列表整理,答案最多5个
        //   for(let i=1;i<=5;i++){
        //       let _key = `answer${i}`;
        //       pd.answer = [];//判断答案列表
        //       dx.answer = [];//单选答案列表
        //       duox.answer = [];//多选答案列表
        //       if(dx[_key]){
        //           dx.answer.push({
        //               idx:i,
        //               answer:dx[_key],
        //           });
        //       }
        //       if(duox[_key]){
        //           duox.answer.push({
        //               idx:i,
        //               answer:duox[_key],
        //           });
        //       }
        //   }
      });
    }
  }
};
</script>

<style lang="scss">
.exam {
  .banner {
    background: url(~@/assets/img/school/h1.png) no-repeat center;
    height: 235px;
    background-size: 100% 100%;
  }
  .exam_box {
    padding: 20px 40px 40px;
    .exam_box_tit {
      font-size: 18px;
      height: 58px;
      line-height: 58px;
      color: rgba(76, 80, 98, 1);
      font-weight: bold;
      border-bottom: 3px solid #ff743c;
    }
    .exam_list {
      padding: 30px 0 0;
      .exam_list_tit {
        font-size: 16px;
        color: rgba(255, 116, 60, 1);
        padding-left: 10px;
        height: 54px;
        line-height: 54px;
        position: relative;
      }
      .exam_list_tit::after {
        content: "";
        width: 3px;
        height: 16px;
        background: rgba(255, 116, 60, 1);
        position: absolute;
        left: 0;
        top: 18px;
      }
      .el-form-item__label {
        font-size: 16px;
        color: rgba(76, 80, 98, 1);
      }
      .el-radio {
        margin-bottom: 20px;
      }
    }
  }
}
</style>
